const links = [
  {
    text: 'welcome.linksDownload',
    link: {
      de: 'https://wiser.feller.ch/de/professionals/services',
      en: 'https://wiser.feller.ch/de/professionals/services',
      fr: 'https://wiser.feller.ch/fr/professionals/services',
      it: 'https://wiser.feller.ch/it/professionals/services',
    },
  },
  {
    text: 'welcome.linksDownloadCenter',
    link: {
      de: 'https://online-katalog.feller.ch/download/index.php?sc_lang=de',
      en: 'https://online-katalog.feller.ch/download/index.php?sc_lang=de',
      fr: 'https://catalogue-online.feller.ch/download/index.php?sc_lang=fr',
      it: 'https://catalogo-online.feller.ch/download/index.php?sc_lang=it',
    },
  },
  {
    text: 'welcome.linksCatalog',
    link: {
      de: 'https://online-katalog.feller.ch/kat.php',
      en: 'https://online-katalog.feller.ch/kat.php',
      fr: 'https://catalogue-online.feller.ch/kat.php',
      it: 'https://catalogo-online.feller.ch/kat.php',
    },
  },
  {
    text: 'welcome.linksWebsite',
    link: {
      de: 'https://www.feller.ch/?sc_lang=de',
      en: 'https://www.feller.ch',
      fr: 'https://www.feller.ch/?sc_lang=fr',
      it: 'https://www.feller.ch/?sc_lang=it',
    },
  },
];

export default links;
